/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_InzercerealityInputs */

const cs_enum_inzercereality = /** @type {(inputs: Enum_InzercerealityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inzercereality`)
};

const en_enum_inzercereality = /** @type {(inputs: Enum_InzercerealityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inzercereality`)
};

/**
* | output |
* | --- |
* | "Inzercereality" |
*
* @param {Enum_InzercerealityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_inzercereality = /** @type {((inputs?: Enum_InzercerealityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_InzercerealityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_inzercereality(inputs)
	return cs_enum_inzercereality(inputs)
});